export const PROPOSAL_MODAL_NAME = 'PROPOSAL_MODAL_NAME';
export const PROPOSAL_NOT_CREATE_MODAL_NAME = 'PROPOSAL_NOT_CREATE_MODAL_NAME';
export const AMOUNT_TOKEN_PROPOSAL_TRANSFER = 100000;
